import { useEffect, useState } from 'react';
import FileService from '../../../../services/file_service';

const File = (props) => {
  const [fileUrl, setFileUrl] = useState(null);

  useEffect(() => {
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [fileUrl]);

  const handleViewTerms = async () => {
    const lostAccess = await props.losesAccess?.();
    if (lostAccess) return;
    try {
      const file = await FileService.getTermsFile();
      if (props.logout(file)) return;
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
      const url = URL.createObjectURL(file);
      setFileUrl(url);
    } catch (e) {
      props.message?.(e?.message || e, 'error');
    }
  };

  const handleCloseViewer = () => {
    if (fileUrl) URL.revokeObjectURL(fileUrl);
    setFileUrl(null);
  };

  const handleChangeFile = async (ex) => {
    const lostAccess = await props.losesAccess?.();
    if (lostAccess) return;
    const file = ex.target.files?.[0];
    if (!file) return;
    try {
      const fileUpdate = await FileService.uploadTermsFile(file);
      if (props.logout(fileUpdate)) return;
      props.message?.('Archivo cargado correctamente', 'success');
    } catch (e) {
      props.message((e?.message || e), "error");
    } finally {
      ex.target.value = '';
    }
  };

  return {
    fileUrl,
    handleViewTerms,
    handleCloseViewer,
    handleChangeFile
  }
};

export default File;
